// extracted by mini-css-extract-plugin
export default {"footer":"AdminApiView-module__footer--nG56g","footerContact":"AdminApiView-module__footerContact--YMqVq","animatedBackground":"AdminApiView-module__animatedBackground--rdWsy"};